import { makeStyles } from "@material-ui/core";

export default function LyfeStatus(props: { type: number }) {
	const { type } = props;
	const classes = useStyles();

	function getAuraColour() {
		switch (type) {
			case 0:
				return `${classes.aura} ${classes.greyAura}`;
			case 1:
				return `${classes.aura} ${classes.orangeAura}`;
			case 2:
				return `${classes.aura} ${classes.blueAura}`;
			case 3:
				return `${classes.aura} ${classes.greenAura}`;
			default:
				return `${classes.aura} ${classes.greyAura}`;
		}
	}

	function getDotColour() {
		switch (type) {
			case 0:
				return `${classes.dot} ${classes.greyDot}`;
			case 1:
				return `${classes.dot} ${classes.orangeDot}`;
			case 2:
				return `${classes.dot} ${classes.blueDot}`;
			case 3:
				return `${classes.dot} ${classes.greenDot}`;
			default:
				return `${classes.dot} ${classes.greyDot}`;
		}
	}

	return (
		<div className={getAuraColour()}>
			<div className={getDotColour()}></div>
		</div>
	);
}

const useStyles = makeStyles((theme) => ({
	greyDot: {
		backgroundColor: theme.palette.grey[600],
	},
	greyAura: {
		backgroundColor: theme.palette.grey[100],
	},
	greenDot: {
		backgroundColor: theme.palette.secondary.dark,
	},
	greenAura: {
		backgroundColor: theme.palette.secondary.light,
	},
	blueDot: {
		backgroundColor: theme.palette.primary.main,
	},
	blueAura: {
		backgroundColor: theme.palette.primary.light,
	},
	orangeDot: {
		backgroundColor: theme.palette.warning.main,
	},
	orangeAura: {
		backgroundColor: theme.palette.warning.light,
	},
	aura: {
		color: "white",
		width: "20px",
		height: "20px",
		borderRadius: "50%",
		margin: "0 auto",
		position: "relative",
	},
	dot: {
		width: "10px",
		height: "10px",
		borderRadius: "50%",
		margin: "0 auto",
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: "-5px" /* half the height */,
		marginLeft: "-5px" /* half the width */,
	},
}));
